import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { baseurl, imageUrl } from "../../Baseurl";
import Swal from "sweetalert2"; // Import SweetAlert2 
import CategoryNavbar from "./AdminComp/CategoryNavbar";
import AllMainCategory from "./AdminComp/AllMainCategory";
import AllMainSubCategory from "./AdminComp/AllMainSubCategory";


const CategoryBuilderSub = () => {
  const [menus, setMenus] = useState([]);
 
  const navigate = useNavigate();

 
 
 

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />

      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Sub Category</h4>
           
          </div>
 
<CategoryNavbar/>
 
<div className="">
<div className="row g-3">
 
<div className="col-md-12">
    <div className="crd1">
  
   

    <AllMainSubCategory/>


    </div>
    
</div>
</div>
</div>




           

           
        </div>
      </div>
    </div>
  );
};

export default CategoryBuilderSub;
